import { AppThunk } from '../../../../../store/types';
import { ContentLibActions } from '../../../../../store/contentLib/actions';
import { EContentLibViewMode } from '../../../../../store/contentLib/types';
import { EUserLevel } from '../../../../../store/general/types';
import { ContentLibSelectors } from '../../../../../store/contentLib/selectors';
import { Navigator } from '../../../../../effects/navigator';

export class ContentLibraryFiltersEvents {

	public static onTextChange(text: string): AppThunk {
		return (
			dispatch,
			getState
		) => {
			const { text: prev } = ContentLibSelectors.getSearchFilter(getState());
			if (text !== prev) {
				dispatch(ContentLibActions.setViewMode(EContentLibViewMode.VIDEO_LIST));
				dispatch(ContentLibActions.setSearchFilter({ text }));
			}
		}
	}
	
	public static onLevelChange(level: EUserLevel): AppThunk {
		return (
			dispatch,
			getState
		) => {
		  	dispatch(ContentLibActions.setSearchFilter({ level }));
			Navigator.navigateContentLib();
		}
	}

	public static onOpenCategories(isOpen: boolean): AppThunk {
		return (
			dispatch,
			getState
		) => {
		  	dispatch(ContentLibActions.setOpenCategories(isOpen));
		}
	}

}